import React from "react"
import { MdOutlineInfo } from "react-icons/md"

const BasicInput = ({
    label,
    value,
    feature,
    onChange,
    error,
    helperText,
    info,
    type = "text",
    options = [],
    errormessage,
    disabled,
    hideLabel,
    styling,
    inputCenter,
    ...props
}) => {
    const renderLabel = () => (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "4px"
            }}
            className="label"
        >
            {label}
            {info && (
                <span
                    className="d-inline-flex align-items-center ms-1"
                    data-bs-toggle="tooltip"
                    title={info}
                >
                    <MdOutlineInfo fontSize="inherit" />
                </span>
            )}
        </div>
    )

    // Handle number input scroll prevention
    const handleWheel = (e) => {
        if (type === "number") {
            e.preventDefault()
        }
    }

    // Helper function to get display value
    const getDisplayValue = () => {
        return value !== undefined && value !== null ? value : ""
    }

    // Helper to handle onChange
    const handleChange = (e) => {
        const newValue = type === "select" ? e.target.value : e.target.value
        onChange(feature?.path || feature?.slug, newValue)
    }

    return (
        <div
            style={{ marginBottom: "1rem", ...styling }}
            className={`custom-input row align-items-center ${inputCenter ? 'text-center' : ''}`}
        >
            {/* LABEL */}
            {!hideLabel && (
                <div className="col-md-3">
                    <label className="form-label fw-medium">{renderLabel()}</label>
                </div>
            )}

            {/* INPUT */}
            <div className={`${!hideLabel ? "col-md-8 m-0 p-0" : "col-12"} actual-input`}>
                {/* SELECT */}
                {type === "select" ? (
                    <div className="mb-0">
                        <select
                            className={`form-select form-select-sm ${error ? 'is-invalid' : ''}`}
                            value={getDisplayValue()}
                            disabled={disabled}
                            onChange={handleChange}
                            style={{
                                width: "100%",
                                border: "none",
                                borderBottom: "1px solid #ced4da",
                                borderRadius: "0",
                                padding: "0 0 4px 0"
                            }}
                            {...props}
                        >
                            {options.map(opt => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                        {error && errormessage && (
                            <div className="invalid-feedback d-block">
                                {errormessage}
                            </div>
                        )}
                        {!error && helperText && (
                            <small className="text-muted">{helperText}</small>
                        )}
                    </div>
                ) : type === "radio" ? (
                    <div>
                        <div className="d-flex flex-wrap gap-3">
                            {options.map(opt => (
                                <div className="form-check" key={opt.value}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name={feature?.slug || "radio-group"}
                                        id={`${feature?.slug || "radio"}-${opt.value}`}
                                        value={opt.value}
                                        checked={getDisplayValue() === opt.value}
                                        onChange={handleChange}
                                        disabled={disabled}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`${feature?.slug || "radio"}-${opt.value}`}
                                    >
                                        {opt.label}
                                    </label>
                                </div>
                            ))}
                        </div>
                        {error && errormessage && (
                            <div className="text-danger small">{errormessage}</div>
                        )}
                        {!error && helperText && (
                            <small className="text-muted">{helperText}</small>
                        )}
                    </div>
                ) : (
                    <div className="mb-0">
                        <input
                            type={type === "number" ? "text" : type}
                            className={`form-control form-control-sm ${error ? 'is-invalid' : ''}`}
                            value={getDisplayValue()}
                            disabled={disabled}
                            onChange={handleChange}
                            onWheel={handleWheel}
                            style={{
                                width: "100%",
                                border: "none",
                                borderBottom: "1px solid #ced4da",
                                borderRadius: "0",
                                padding: "0 0 4px 0",
                                backgroundColor: disabled ? "#e9ecef" : "transparent"
                            }}
                            {...props}
                        />
                        {error && errormessage && (
                            <div className="invalid-feedback d-block">
                                {errormessage}
                            </div>
                        )}
                        {!error && helperText && (
                            <small className="text-muted">{helperText}</small>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default BasicInput